module.exports = __webpack_public_path__ + "static/images/unionpay.3BinMEV.svg";